import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { InfoIcon } from "../../Assets/assets";
import Button from "../../Components/Button/Button";
import InputBox from "../../Components/InputBox/InputBox";
import {
  checkProfileAction,
  login,
  resetAuthTransaction,
  sendPasswordRestEmailAction
} from "../../Redux/authentication/actions";
import { Regex } from "../../Utils/Constants/Constants";
import "./Login.css";
import { isValidObject } from "../../Services/validators";
import Timer from "../../Components/Timer/Timer";

function Login(props) {
  const [loginFormData, setLoginFormData] = useState({
    email: "",
    password: ""
  });
  const [isTimerActive, setIsTimerActive] = useState(false);

  useEffect(() => {
    if (
      isValidObject(props.auth.transaction) ||
      isValidObject(props.auth.accountInfo)
    )
      props.resetTransaction();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (props.auth?.transaction?.resetEmailSent) {
      setIsTimerActive(true);
    }
  }, [props.auth?.transaction?.resetEmailSent]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (props.auth?.transaction?.resetEmailSent) {
      props.sendResetEmail(loginFormData.email);
      setIsTimerActive(true);
    } else if (!props.auth?.accountInfo) {
      props.checkProfile(loginFormData.email);
    } else {
      props.login(loginFormData.email, loginFormData.password);
    }
  };
  return (
    <div
      className="z-index-101 background-color-black-with-opacity-light position-fixed top-0 bottom-0 right-0 left-0 inherit-parent-height inherit-parent-width display-flex flex-justify-content-center flex-align-items-center"
      data-cy="login-modal-background"
    >
      <div
        className="background-color-primary width-500px padding-large box-shadow-default border-radius-default flex-direction-column flex-justify-content-center flex-align-items-center padding-larger"
        data-cy="login-modal"
      >
        <div className="font-size-large padding-top-large font-color-tertiaryColor6">
          SIGN IN
        </div>
        <div className="font-size-medium padding-top-large font-color-tertiaryColor6">
          Get access to control center
        </div>
        <form
          className="width-400px padding-horizontal-larger flex-justify-content-space-between flex-direction-column"
          onChange={(event) => {
            const { name, value } = event.target;

            setLoginFormData((prevData) => ({
              ...prevData,
              [name]: value
            }));

            if (
              name === "email" &&
              (isValidObject(props.auth.accountInfo) ||
                isValidObject(props.auth.transaction))
            ) {
              props.resetTransaction();
            }
          }}
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <div>
            <InputBox
              className="inherit-parent-width padding-top-larger"
              name="email"
              label="Email"
              type="email"
              autoFocus={true}
              boxShadow={false}
              removeResponsive={true}
              autoComplete="off"
              value={loginFormData.email}
              fontColor="font-color-tertiaryColor"
              labelFontColor="font-color-tertiaryColor"
              validation={(value) => {
                if (!props.auth?.accountInfo && !Regex.email.test(value)) {
                  return {
                    status: false,
                    message: "Please enter a valid email"
                  };
                }
              }}
              data-cy="login-screen-email-field"
              required
            />
            {props.auth?.transaction?.resetEmailSent && (
              <div className="display-flex margin-top-default">
                <InfoIcon width="25px" color="var(--tertiaryColor6)" />
                <div className="font-color-tertiaryColor6 font-size-medium margin-left-default">
                  This account doesn't have a password. To set a new password,
                  use the link sent to your email
                </div>
              </div>
            )}
            {props.auth?.accountInfo?.accountExists === false && (
              <div className="display-flex margin-top-default">
                <InfoIcon width="25px" color="var(--tertiaryColor6)" />
                <div className="font-size-medium margin-left-default font-color-tertiaryColor6">
                  This email is not registered
                </div>
              </div>
            )}

            {props.auth?.accountInfo?.accountExists &&
              props.auth?.accountInfo?.profileExists &&
              !props.auth?.accountInfo?.neverLoggedIn && (
                <InputBox
                  className="inherit-parent-width padding-top-larger"
                  name="password"
                  label="Password"
                  type="password"
                  autoFocus={true}
                  removeResponsive={true}
                  autoComplete="off"
                  value={loginFormData.password}
                  fontColor="font-color-tertiaryColor"
                  labelFontColor="font-color-tertiaryColor"
                  data-cy="login-screen-password-field"
                  required
                />
              )}
          </div>

          <Button
            data-cy={
              props.auth.loading ? "login-loading-button" : "login-button"
            }
            loading={props.auth.loading}
            type="submit"
            className="margin-top-larger margin-bottom-larger"
            text={
              props.auth?.transaction?.resetEmailSent ? (
                isTimerActive ? (
                  <>
                    Resend Email in{" "}
                    <Timer onComplete={() => setIsTimerActive(false)} />s
                  </>
                ) : (
                  "Resend Email"
                )
              ) : props.auth?.accountInfo?.accountExists &&
                props.auth?.accountInfo?.profileExists &&
                !props.auth?.accountInfo?.neverLoggedIn ? (
                "Login"
              ) : (
                "Continue"
              )
            }
            disabled={
              (props.auth.accountInfo &&
                !Regex.email.test(loginFormData.email)) ||
              (props.auth?.accountInfo?.accountExists &&
                props.auth?.accountInfo?.profileExists &&
                !props.auth?.accountInfo?.neverLoggedIn &&
                loginFormData.password.length < 6) ||
              (isValidObject(props.auth?.accountInfo) &&
                !props.auth?.accountInfo?.accountExists) ||
              (props.auth?.transaction?.resetEmailSent && isTimerActive) ||
              !Regex.email.test(loginFormData.email)
            }
          />
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = function(state) {
  return {
    auth: state.auth
  };
};

const mapDispatchToProps = function() {
  return {
    login: (email, password) => login(email, password),
    checkProfile: (email) => checkProfileAction(email),
    sendResetEmail: (email) => sendPasswordRestEmailAction(email),
    resetTransaction: () => resetAuthTransaction()
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
